// src/components/ActiveSwarmCard/GradientOverlay.js

import React from 'react';
import PropTypes from 'prop-types';
import './GradientOverlay.css';

/**
 * GradientOverlay Component
 * Renders a gradient overlay on the card when active.
 * 
 * @param {Object} props
 * @param {boolean} props.active - Determines if the gradient should be visible.
 * @param {string} props.background - CSS background property for the gradient.
 * @returns {JSX.Element}
 */
const GradientOverlay = ({ active, background }) => (
  <div
    className={`gradient-overlay-element ${active ? 'gradient-active' : ''}`}
    style={{ background }}
  />
);

GradientOverlay.propTypes = {
  active: PropTypes.bool.isRequired,
  background: PropTypes.string.isRequired,
};

export default GradientOverlay;
